<div class="pb-5 pt-5">
	<p-dropdown
		(onChange)="selectedPropertyChange($event)"
		[(ngModel)]="selectedProperty"
		[options]="properties"
		optionLabel="name"
		[filter]="true"
		filterBy="name"
		[showClear]="false"
		name="selectedProperty"
		placeholder="Select a Property"
		styleClass="property-dropdown"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="selectedProperty">
				<div>
					{{ selectedProperty.name }}
				</div>
			</div>
		</ng-template>

		<ng-template let-property pTemplate="item">
			<div>
				<div>
					{{ property.name  }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

